/**
 * Main entry point for the UltraSwim 33.3 Ranking Visualization
 */

import { RankingVisualization } from './core/RankingVisualization';
import { updatePageTitle } from './utils/pageTitle';

// Initialize visualization when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Update page title based on race parameter
    updatePageTitle();

    // Initialize visualization
    new RankingVisualization();
});
